import { render, staticRenderFns } from "./ActivitiesTemplates.vue?vue&type=template&id=e201fce0"
import script from "./ActivitiesTemplates.vue?vue&type=script&lang=ts"
export * from "./ActivitiesTemplates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports